import { AnyAction } from "redux";
import { FETCH_SETTINGS } from "../actions/settings";
import { FeatureSettings } from "../models";

const initialState: FeatureSettings = {
    settings: [],
};

const featureSettingsReducer = (state = initialState, action: AnyAction) => {
    switch (action.type) {
        case FETCH_SETTINGS:
            return {
                ...state,
                settings: action.payload,
            };
        default:
            return state;
    }
};

export default featureSettingsReducer;
